import { type OnboardingSlideKey } from '../model';

import { BenefitsSlide } from './slides/benefits-slide';
import { CostsSlide } from './slides/costs-slide';
import { WelcomeSlide } from './slides/welcome-slide';

type OnboardingSlideContentProps = {
  slideKey: OnboardingSlideKey;
};

export function OnboardingSlideContent({
  slideKey,
}: OnboardingSlideContentProps) {
  if (slideKey === 'costs') {
    return <CostsSlide />;
  }

  if (slideKey === 'benefits') {
    return <BenefitsSlide />;
  }

  return <WelcomeSlide />;
}
